import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { BookingCategory } from './booking-types.types'

export const USE_GET_BOOKING_CATEGORIES_QUERY_KEY = 'useGetBookingCategories'

export const getBookingCategories = async (signal?: AbortSignal) => {
  const response = await authAPI.get<BookingCategory[]>('/booking-category/all', { signal })
  return response.data
}

export const useGetBookingCategories = () => {
  return useQuery({
    queryFn: ({ signal }) => getBookingCategories(signal),
    queryKey: [USE_GET_BOOKING_CATEGORIES_QUERY_KEY],
  })
}

export const useInvalidateBookingCategories = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_BOOKING_CATEGORIES_QUERY_KEY] })
}
